module.exports = __webpack_public_path__ + "static/img/iconfont.09c9ad48.svg";